
<div *ngIf="campus && !loadingData" class="d-flex flex-nowrap flex-column justify-content-stretch align-items-stretch h-100 v-100 m-0">
    
    <!-- Header -->
    <app-header class="custom-main-header"></app-header>
    
    <div id="main-content" class="custom-main-content d-flex flex-column justify-content-start align-items-stretch h-100">
  
        <!-- Content -->
        <div class="custom-main-router-outlet flex-grow-1">
            <router-outlet (activate)="onActivate()"></router-outlet>
        </div>

        <!-- Footer -->
        <app-footer class="custom-main-footer"></app-footer>
  
    </div>
  
</div>

<div *ngIf="!campus && loadingData">
    <app-spinner-main></app-spinner-main>
</div>

<div *ngIf="!campus && !loadingData">
    <app-not-available></app-not-available>
</div>